import React from "react";

const WebPages_Charts = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Charts</h1>
      <p>This is the WebPages Charts page content.</p>
    </div>
  );
};

export default WebPages_Charts;
